
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CustomerOperationLogEntry": [
      "CustomerCreateLogEntry",
      "CustomerDeactivationLogEntry",
      "CustomerMergeLogEntry",
      "CustomerUpdateLogEntry",
      "CustomerVisitCreateLogEntry",
      "CustomerVisitDeactivationLogEntry",
      "CustomerVisitUpdateLogEntry",
      "KarteCreateLogEntry",
      "KarteDeactivationLogEntry",
      "KarteUpdateLogEntry",
      "TodoArchiveLogEntry",
      "TodoCompleteLogEntry",
      "TodoCreateLogEntry",
      "TodoDeactivationLogEntry",
      "TodoRejectionLogEntry",
      "TodoReopenLogEntry",
      "TodoUpdateLogEntry"
    ],
    "OperationActor": [
      "OperationApiKeyActor",
      "OperationAppActor",
      "OperationEsStaffAssignmentActor",
      "OperationSyncActor",
      "OperationSystemActor",
      "OperationUnknownActor",
      "OperationUserActor",
      "OperationWebhookActor"
    ],
    "RealtimeTranscriptResult": [
      "Failed",
      "RealtimeTranscript"
    ],
    "RecordingSessionDisplayableContent": [
      "Karte",
      "RealtimeKartePreview"
    ],
    "TranscriptAnalyzerResultData": [
      "TranscriptExtractCustomerNamesData",
      "TranscriptSpeakerClassificationData"
    ],
    "TranscriptContentResult": [
      "Failed",
      "TranscriptContent"
    ]
  }
};
      export default result;
    